const TAG_COLORS = [
    '#6366f1', '#ec4899', '#f59e0b', '#10b981',
    '#3b82f6', '#ef4444', '#8b5cf6', '#14b8a6',
    '#f97316', '#84cc16',
]

function hashString(value) {
    let hash = 0
    for (let i = 0; i < value.length; i++) {
        hash = (hash * 31 + value.charCodeAt(i)) >>> 0
    }
    return hash
}

export function useTagColors() {
    function getTagColor(tag) {
        if (!tag) {
            return TAG_COLORS[0]
        }
        return TAG_COLORS[hashString(tag) % TAG_COLORS.length]
    }

    return { TAG_COLORS, getTagColor }
}
